import { Center, EmailIcon, IconProps } from '@chakra-ui/icons'
import { colors, patientColor } from '@hb/shared'
import './styles.css'

const UnreadIcon = ({
  color,
  _dark,
  unread,
  unreadType = 'assessment',
  position = 'relative',
  left,
  right,
}: {
  color: string
  _dark?: IconProps['_dark']
  unread: boolean
  unreadType?: 'assessment' | 'patient'
  position?: 'relative' | 'absolute'
  left?: string
  right?: string
}) => (
  <EmailIcon
    className={unread ? `unread-message-badge-${unreadType}` : 'read-message-badge'}
    width="20px"
    background="transparent"
    position={position}
    height="20px"
    color={color}
    _dark={_dark}
    left={left}
    right={right}
  />
)

export const UnreadMessagesBadge = ({
  patientUnread,
  assessmentUnread,
}: {
  patientUnread: boolean
  assessmentUnread: boolean
}) => {
  if (!patientUnread && !assessmentUnread) {
    return <UnreadIcon color="gray.400" unread={false} />
  }
  if (patientUnread && !assessmentUnread) {
    return <UnreadIcon unreadType="patient" color={patientColor} unread={patientUnread} />
  }
  if (!patientUnread && assessmentUnread) {
    return <UnreadIcon unreadType="assessment" color={colors.green.hex} unread={assessmentUnread} />
  }
  return (
    <Center>
      <Center position="relative" w="15px" h="20px" overflow="hidden">
        <UnreadIcon unread left="5px" color={colors.green.hex} position="absolute" />
      </Center>
      <Center position="relative" w="15px" h="20px" overflow="hidden">
        <UnreadIcon
          unread
          position="absolute"
          right="5px"
          unreadType="patient"
          color={patientColor}
        />
      </Center>
    </Center>
  )
}

export const PracticeUnreadMessagesBadge = ({ unread }: { unread: boolean }) => (
  <UnreadIcon
    unreadType="assessment"
    color={unread ? colors.green.hex : 'gray.400'}
    unread={unread}
    _dark={{ color: unread ? colors.neongreen.hex : 'gray.300' }}
  />
)

export const UnreadMessagesHeaderBadge = ({ active }: { active: boolean }) => (
  <UnreadIcon
    color={active ? colors.green.hex : 'gray.400'}
    _dark={{ color: active ? colors.neongreen.hex : 'gray.300' }}
    unread={active}
  />
)
